import axios from 'axios';

// FEAT-01 — companies customers belong to.
let prefix = "/company"

const CompanyApi = {

	getCompanyList(payload){
		return axios.get( prefix + "/list", {params: payload})
	},
	getCompanyById(id){
		return axios.get( prefix + "/get/" + id)
	},
	createCompany(payload){
		return axios.post( prefix + "/create", payload)
	},
	updateCompany(payload){
		return axios.post( prefix + "/update", payload)
	},
	deleteCompany(id){
		return axios.delete( prefix + "/delete", {params: {id: id}})
	},
	linkCompanyCustomers(payload){
		return axios.post( prefix + "/link-customers", payload)
	},
	unlinkCompanyCustomer(payload){
		return axios.post( prefix + "/unlink-customer", payload)
	},
}

export default CompanyApi;
